import { UNDER_WAY } from '../lib/callLists';
import type { DriverCall } from '../services/driverApi';
import { isValidDriverRecordId } from '../utils/driverRecordId';
import { useDriverCalls } from './useDriverCalls';
import { useDriverProfile } from './useDriverProfile';

/**
 * The calls the signed-in driver is on, for the pill above the tab bar:
 * empty, one it names, or several it counts. Read from their own board
 * (calls assigned to them today), which the server scopes; an office member
 * with no Driver row has none.
 */
export const useActiveCalls = (): DriverCall[] => {
  const { data: profile } = useDriverProfile();
  const hasDriverRow = !!profile && isValidDriverRecordId(profile.id);
  const { data } = useDriverCalls(undefined, {
    queryEnabled: hasDriverRow,
    companyId: profile?.companyId || undefined,
  });
  return data?.data.filter((call) => UNDER_WAY.has(call.status)) ?? [];
};
